import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash Refund"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash-refund',
    templateUrl: './icon-cash-refund.component.html',
    styleUrls: ['./icon-cash-refund.component.scss'],
    standalone: false
})
export class IconCashRefundComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
